export default {
  title: {
    id: 'asp_action_bar_declare_problem_out_of_warranty_upload_step_title',
    defaultMessage: 'Upload photos & report for the agent to review',
  },
  outOfWarranty: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_out_of_warranty',
    defaultMessage: 'Item is out of warranty',
  },
  intro: {
    id: 'asp_action_bar_declare_problem_out_of_warranty_upload_step_form_intro',
    defaultMessage:
      'The agent will check the photos and test report, confirm their findings with you, and suggest next steps.',
  },
  uploadFieldLabel: {
    id: 'asp_action_bar_declare_problem_out_of_warranty_upload_step_upload_field',
    defaultMessage: 'Upload',
  },
  hintTitle: {
    id: 'asp_action_bar_declare_problem_out_of_warranty_upload_step_hint_title',
    defaultMessage: 'Upload:',
  },
  hint1: {
    id: 'asp_action_bar_declare_problem_out_of_warranty_upload_step_hint_1',
    defaultMessage: 'Photos of the device',
  },
  hint2: {
    id: 'asp_action_bar_declare_problem_out_of_warranty_upload_step_hint_2',
    defaultMessage: 'Test report',
  },
}
